import * as types from './mutation-types'

export default {
    [types.SET_INITIAL_DATA](state, data) {
        state.invoices = data.invoicesCount
        state.contacts = data.customersCount
    },

    [types.GET_INITIAL_DATA](state, data) {
        state.isDataLoaded = data
    },
    [types.SET_INVOICE_GROUP_COUNT](state, data) {
        state.invoiceGroupCount = data
    },
}
